import React from "react";

import moment from "moment";

import { Anchor, Col, Divider, Row, Typography } from "components";

export const PageActivityTab = ({ user }) => (
  <>
    <Row>
      <Col>
        <Typography variant="paragraph-m" className="margin-0">
          MainPage view data is only retained for 90 days, after which it becomes anonymized.
        </Typography>
      </Col>
    </Row>
    {user.pages.length > 0 && (
      <Row>
        <Col sm={24} md={12}>
          {user.pages.map((item, i) => (
            <Row key={i}>
              <Col>
                <Typography variant="paragraph-m" key={i}>
                  <Anchor href={`${process.env.REACT_APP_FARM_URL}${item.page}`} target="_blank" mixpanelText={item.page}>
                    <b>{item.page}</b>
                  </Anchor>
                  <br />
                  <small>Viewed on {moment.utc(item.date).format("DD.MM.YYYY")}</small>
                </Typography>
                <Divider />
              </Col>
            </Row>
          ))}
        </Col>
      </Row>
    )}
  </>
);
